// extracted by mini-css-extract-plugin
export default {"SegmentedControl":"📚19-10-2_fD8_","shape_pill":"📚19-10-2ssIJF","shape_rounded":"📚19-10-2f29hR","shape_squared":"📚19-10-2FwAaH","size_small":"📚19-10-2QLXE_"};